import { Injectable } from '@angular/core';
import { AppConfig } from '../app-config.loader';
import { Statistica } from '../shared/models/statistica';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http'; // Import HttpResponse type
import { StoricoStatistiche } from '../shared/models/storicostatistiche';
@Injectable({ providedIn: 'root' })
export class StatisticheService {
  private apiBaseUrl: string;

  constructor(appConfig: AppConfig, private http: HttpClient) {
    this.apiBaseUrl = `${appConfig.settings.apiRoot}`;
  }

  public getStoricoStatistiche(): Observable<StoricoStatistiche[]>  { 

    return this.http.get<StoricoStatistiche[]>(`${this.apiBaseUrl}/statistiche/StoricoStatistiche`);
    
  }

  public getInCarico(year?: string): Observable<Statistica[]>  { 
    if (year) {
      return this.http.get<Statistica[]>(`${this.apiBaseUrl}/statistiche/InCarico/${year}`);
    } else {
    return this.http.get<Statistica[]>(`${this.apiBaseUrl}/statistiche/InCarico`);
    }
  }

  public getDistrutti(year?: string): Observable<Statistica[]>  { 
    if (year) {
      return this.http.get<Statistica[]>(`${this.apiBaseUrl}/statistiche/Distrutti/${year}`);
    } else {
    return this.http.get<Statistica[]>(`${this.apiBaseUrl}/statistiche/Distrutti`);
    }
  }

  public getVersati(year?: string): Observable<Statistica[]>  { 
    if (year) {
      return this.http.get<Statistica[]>(`${this.apiBaseUrl}/statistiche/Versati/${year}`);
    } else {
    return this.http.get<Statistica[]>(`${this.apiBaseUrl}/statistiche/Versati`);
    }
  }

  public getDeclassificati(year?: string): Observable<Statistica[]>  { 
    if (year) {
      return this.http.get<Statistica[]>(`${this.apiBaseUrl}/statistiche/Declassificati/${year}`);
    } else {
    return this.http.get<Statistica[]>(`${this.apiBaseUrl}/statistiche/Declassificati`);
    }
  }
}
